import { createSelector } from "reselect";
import { BreakpointDefinition } from "utils/Breakpoint";

import getBreakpoint from "./getBreakpoint";

export default createSelector([getBreakpoint], (breakpoint) =>
  breakpoint.isGreaterThanOrEquals(BreakpointDefinition.SM),
);
